import { Transaction } from "../models/Transaction";
import { Cols } from "../shared/Consts";
import { usePath } from "../libs/path/PathProvider";
import usePortfolio from "../hooks/PortfolioProvider";
import PortUtils from "../portlibs/PortUtils";
import TransactionTable from "../components/widgets/TransactionTable";
import HistoryToolbar from "../components/history/HistoryToolbar";

export default function HistoryPage(){
    const {query} = usePath()
    const {account,currency,filter} = PortUtils.getFilter(query)
    const {portfolio} = usePortfolio()
    const cols = [Cols.date, Cols.name, Cols.accountId, Cols.type, Cols.quantity, Cols.price, Cols.total, Cols.gain, Cols.note]
    const holdings = portfolio.filter(currency,filter,account,false)
    const rows : Transaction[] = []
    for(let holding of holdings){
        if (holding.isCash) continue
        
        const {transactions} = PortUtils.excludeFilter(holding.transactions, {} as any)
        rows.push(...transactions)
    }
    return <>
        <HistoryToolbar/>
        <div id="history" className="flex1 scroller"><TransactionTable tableName="history" cols={cols} rows={rows} infiniteScroll={true}/></div>
    </>

}